import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-combobox',
  templateUrl: './combobox.component.html',
  styleUrls: ['./combobox.component.scss']
})
export class ComboboxComponent implements OnInit, AfterViewInit {

  @ViewChild('validationForm') validationForm: any;

  @Input() formItem: any;
  @Input() invalidForm: any;
  @Input() formId:any;

  @Output() callUpdate = new EventEmitter();
  @Output() invalidFormChange = new EventEmitter<boolean>();

  radioOptions: any;
  formTitle: string;
  isRequired: string;
  renderType: boolean;

  ngOnInit() {
    // Delete parent BoolValue
    delete this.formItem.boolValue;

    this.isRequired = this.formItem.item.isRequired;
    this.renderType = this.formItem.item.renderType === 1 ? true : false;
    this.formTitle = this.formItem.item.labelField;
    this.radioOptions = this.formItem.item.datasource.datasourcesItems;

  }

  updateConditional() {
    if (this.formItem.item.isConditional) {
      this.callUpdate.emit();
    }
  }

  deleteBoolValue(option: any) {
    delete this.formItem.boolValue;
  }

  // Use this cycle because the view has to render the conditionals
  // The HTML <template> (or ng-container) element is a mechanism for holding client-side content
  // that is not to be rendered when a page is loaded but may subsequently be instantiated
  // during runtime using JavaScript.
  ngAfterViewInit() {
    if (this.isRequired) {
      this.validationForm.control.statusChanges.subscribe(() => {
        this.invalidFormChange.emit(this.validationForm.invalid);
      });
    }
  }

}
